<template>
  <setting-auto-liked-search-form
    v-if="showSearchForm"
    :base-condition-data="searchData"
    :contract-id="contractId"
    @submit="insertAutoLikedSearchCondition"
  />
</template>

<script>
import Indicator from '@/lib/indicator'
import { SearchDataModel } from '@/model/searchDataModel'
import SettingAutoLikedSearchForm from '@/components/organisms/SettingAutoLikedSearchForm'
import { mapGetters } from 'vuex'

export default {
  components: {
    SettingAutoLikedSearchForm
  },
  data () {
    return {
      searchData: new SearchDataModel(),
      showSearchForm: false
    }
  },
  computed: {
    ...mapGetters('contracts', {
      publishedContracts: 'publishedContracts'
    }),
    contractId () {
      return this.publishedContracts[0].id
    }
  },
  created () {
    Indicator.emitShow()
    this.$http.secured.get(`/scout/message/send/auto_liked_settings/jobs/${this.$route.params.jobId}/default_search_conditions`)
      .then(response => {
        // デフォルト値指定：都道府県
        this.$set(this.searchData.parameter.address, 'prefectures', response.data.workPrefectureIds)
      }).finally(() => {
        Indicator.emitHide()
        // APIが完了してから子コンポーネントの描画を行う
        this.$set(this, 'showSearchForm', true)
      })
  },
  methods: {
    insertAutoLikedSearchCondition (apiConditionParameter) {
      this.$http.secured.post(
        `/scout/message/send/auto_liked_settings/jobs/${this.$route.params.jobId}/search_conditions`,
        { ...apiConditionParameter }
      ).then(() => {
        this.goResults()
      }).catch(error => { throw error })
    },
    goResults () {
      this.$router.push('/settings/auto_liked')
    }
  }
}
</script>
